const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "currentColor",
      stroke: "rgb(51, 100, 175)",
      strokeWidth: 25
    },
    cx: 237.45,
    cy: 258.699,
    rx: 201.656,
    ry: 201.656
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(51, 100, 175)",
      fill: "currentColor",
      strokeWidth: 29
    },
    cx: 236.606,
    cy: 255.331,
    rx: 123.351,
    ry: 123.351
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(51, 100, 175)",
      stroke: "rgb(51, 100, 175)"
    },
    cx: 237.027,
    cy: 257.436,
    rx: 31.153,
    ry: 31.153
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      strokeWidth: 11,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(51, 100, 175)",
      fill: "currentColor"
    },
    points: "356.589 117.667 224.288 251.834 239.699 268.015 376.797 138.716 398.689 145.452 479.519 73.041 424.899 66.562 424.789 11.577 350.695 89.882"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.7675f0465087770d12df24a783cc7991.svg";
export { ForwardRef as ReactComponent };